import makeStyles from "@mui/styles/makeStyles";

import { relativeFills } from "utils/relativeUtils";

export default makeStyles(
  (theme) => ({
    root: {
      position: "relative",
    },
    personHead: {
      display: "block",
      marginBottom: 10,
      width: 56,
      [theme.breakpoints.up("mobile")]: {
        width: 86,
      },
      overflow: "hidden",
      cursor: "pointer",
      fill: theme.palette.relatives.default.background,
    },
    plus: {
      stroke: "#FFF",
      zIndex: 1,
      width: "15%",
    },
    peanut: {
      opacity: 1,
    },
    white: {
      fill: "white",
      "& $peanut": {
        opacity: 0.5,
      },
    },
    ...relativeFills(theme),
  }),
  { name: "CTA" },
);
